import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size"];
import UITabs from 'UIComponents/nav/UITabs';
import GutterContainer from './GutterContainer';
import { jsx as _jsx } from "react/jsx-runtime";
const Tabs = _ref => {
  let {
      size = 'large'
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/_jsx(GutterContainer, {
    size: size,
    children: /*#__PURE__*/_jsx(UITabs, Object.assign({
      panelClassName: "p-x-0 p-y-1",
      wrapperClassName: "base-font-size"
    }, rest))
  });
};
export default Tabs;